import React, { useEffect } from "react";
import { Outlet, Navigate } from "react-router-dom";
import { Layout, theme } from "antd";

import Navbar from "../components/Navigation/NavigationMenu";
import Sidebar from "../components/Sidebar";
import { NavigationPath } from "../helpers/constants";
import { useDispatch } from "react-redux";
import { setLoggedUser } from "../../src/components/Authentication/modules/actions";

const { Content } = Layout;

const PrivateRoute = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setLoggedUser());
  }, []);

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const token = localStorage.getItem("adminToken");

  return token ? (
    <Layout style={{ minHeight: "100vh" }}>
      <Navbar />

      <Layout>
        <Sidebar />
        <Layout
          style={{
            padding: "24px 24px 0 24px",
          }}
        >
          <Content
            style={{
              margin: 0,
              minHeight: 280,
              background: colorBgContainer,
            }}
          >
            <Outlet />
          </Content>
        </Layout>
      </Layout>
    </Layout>
  ) : (
    <Navigate to={NavigationPath.LOGIN_ROUTE} />
  );
};

export default PrivateRoute;
